import React from 'react';
import { AppRoute } from "./index";
import Login from "../pages/Auth/Login";
import Home from "../pages/Home";
import Users from "../pages/Users";
import FormUsers from "../pages/Users/Form";
import Properties from "../pages/Properties";
import FormProprieties from "../pages/Properties/Form";
import ViewProperty from "../pages/ViewProperty";
import Vehicles from "../pages/Vehicles";
import FormVehicles from "../pages/Vehicles/Form";
import HomeVehicles from "../pages/HomeVehicles";
import ViewVehicles from "../pages/ViewVehicles";
import HomeProperties from "../pages/HomeProperties";
import Equipment from "../pages/Equipment";
import FormEquipment from "../pages/Equipment/Form";
import HomeEquipments from "../pages/HomeEquipment";
import ViewEquipment from "../pages/ViewEquipment";
import Banners from "../pages/Banners";
import FormBanners from "../pages/Banners/Form";

const appRoutes: AppRoute[] =  [
    {
        path: '/',
        requiresAuth: false,
        element: <Home />
    },
    {
        path: '/imoveis',
        requiresAuth: false,
        element: <HomeProperties />
    },
    {
        path: '/veiculos',
        requiresAuth: false,
        element: <HomeVehicles />
    },
    {
        path: '/equipamentos',
        requiresAuth: false,
        element: <HomeEquipments />
    },
    {
        path: 'view/imovel/:id',
        requiresAuth: false,
        element: <ViewProperty/>
    },
    {
        path: 'view/veiculo/:id',
        requiresAuth: false,
        element: <ViewVehicles/>
    },
    {
        path: 'view/equipamento/:id',
        requiresAuth: false,
        element: <ViewEquipment/>
    },
    {
        path: '/login',
        requiresAuth: false,
        element: <Login />
    },
    {
        path: '/usuarios',
        requiresAuth: true,
        element: <Users/>
    },
    {
        path: '/usuarios/formulario',
        requiresAuth: true,
        element: <FormUsers />
    },
    {
        path: '/usuarios/formulario/:id',
        requiresAuth: true,
        element: <FormUsers />
    },
    {
        path: '/imoveis/lista',
        requiresAuth: true,
        element: <Properties/>
    },
    {
        path: '/imoveis/formulario',
        requiresAuth: true,
        element: <FormProprieties />
    },
    {
        path: '/imoveis/formulario/:id',
        requiresAuth: true,
        element: <FormProprieties />
    },

    {
        path: '/veiculos/lista',
        requiresAuth: true,
        element: <Vehicles/>
    },
    {
        path: '/veiculos/formulario',
        requiresAuth: true,
        element: <FormVehicles />
    },
    {
        path: '/veiculos/formulario/:id',
        requiresAuth: true,
        element: <FormVehicles />
    },

    {
        path: '/equipamentos/lista',
        requiresAuth: true,
        element: <Equipment/>
    },
    {
        path: '/equipamentos/formulario',
        requiresAuth: true,
        element: <FormEquipment />
    },
    {
        path: '/equipamentos/formulario/:id',
        requiresAuth: true,
        element: <FormEquipment />
    },

    {
        path: '/banners/lista',
        requiresAuth: true,
        element: <Banners/>
    },
    {
        path: '/banners/formulario',
        requiresAuth: true,
        element: <FormBanners/>
    },
    {
        path: '/banners/formulario/:id',
        requiresAuth: true,
        element: <FormBanners />
    },

];

export default appRoutes;